import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Trans } from 'react-i18next';

export const UploadView = () => (
  <div className="flex flex-col items-center justify-center absolute w-full h-full cursor-pointer inset-auto">
    <CloudUploadIcon
      className="text-slate-100"
      sx={{ fontSize: 32, marginBottom: 1 }}
    />
    <div className="flex flex-col items-center text-white">
      <Trans i18nKey="media_section.label.upload" />
    </div>
  </div>
);
